import api from '../../services/api';

export const couriersApi = {
  getAdminSettingCouriers: async (params) => {
    const { data } = await api.get('admins/get_admin_setting_couriers/', { params });
    return data;
  },

  /**
   * Every courier configured in the platform, with the operator that owns each
   * one. Staff only; anybody else gets a 403.
   */
  getStaffSettingCouriers: async (params) => {
    const { data } = await api.get('admins/staff/setting-couriers/', { params });
    return data;
  },

  getCourierTemplates: async () => {
    const { data } = await api.get('admins/get_courier_templates/');
    return data;
  },

  /**
   * @param {object} courierData
   * @param {number|string} [adminId] - Whose configuration this is. Only staff
   *   may name somebody else; for anyone else the backend ignores it and the
   *   row lands on their own account.
   */
  createCourier: async (courierData, adminId) => {
    const { data } = await api.post('admins/create_admin_setting_courier/', {
      setting_courier: courierData,
      ...(adminId ? { admin_id: adminId } : {}),
    });
    return data;
  },

  updateCourier: async (courierId, courierData) => {
    const { data } = await api.patch(`admins/update_admin_setting_courier/${courierId}/`, {
      setting_courier: courierData,
    });
    return data;
  },

  deleteCourier: async (courierId) => {
    const { data } = await api.delete(`admins/delete_admin_setting_courier/${courierId}/`);
    return data;
  }
};
